// src/components/PendingEvaluationsList.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { webhookService } from '../../../services/webhookService';

const PendingEvaluationsList = ({ onSelect }) => {
    const { t } = useTranslation();
    const [evaluations, setEvaluations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadEvaluations();
        const interval = setInterval(loadEvaluations, 30000);
        return () => clearInterval(interval);
    }, []);

    const loadEvaluations = async () => {
        try {
            setLoading(true);
            const data = await webhookService.getPendingEvaluations();
            setEvaluations(data);
        } catch (error) {
            console.error('Erro ao carregar:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                {t('components.pendingEvaluations.loading')}
            </div>
        );
    }

    if (evaluations.length === 0) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <p style={{ fontSize: '24px' }}>📭</p>
                <p style={{ fontSize: '14px', color: '#666' }}>
                    {t('components.pendingEvaluations.empty')}
                </p>
            </div>
        );
    }

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0 }}>{t('components.pendingEvaluations.title')}</h3>
                <span style={{
                    background: '#007bff',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '14px'
                }}>
                    {evaluations.length} {t('components.pendingEvaluations.pending')}
                </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {evaluations.map(item => (
                    <div key={item.id} style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef',
                        transition: 'all 0.2s'
                    }}>
                        <div>
                            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                {item.projectNo || t('components.pendingEvaluations.noProject')}
                            </div>
                            <div style={{ fontSize: '14px', color: '#666' }}>
                                {item.clientName || t('components.pendingEvaluations.noClient')}
                                {item.dateOfInspection && ` • ${item.dateOfInspection}`}
                            </div>
                            <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                                {t('components.pendingEvaluations.inspector')}: {item.inspectorName || 'N/A'}
                            </div>
                        </div>
                        <button
                            onClick={() => onSelect(item.id)}
                            style={{
                                padding: '8px 20px',
                                background: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.background = '#218838'}
                            onMouseLeave={(e) => e.target.style.background = '#28a745'}
                        >
                            {t('components.pendingEvaluations.generateReport')}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PendingEvaluationsList;